import { CustomTranslationsService } from 'src/app/operational-data-common/translations';
import { Injectable } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import { TranslateService } from '@ngx-translate/core';

import { map, Observable } from 'rxjs';
import { PowerLimitationTooltip } from '@vi-iot/client/index';

@Injectable({
  providedIn: 'root',
})
export class InstallationDetailsMappingService {
  constructor(
    private installationStore: InstallationFeaturesStore,
    private customTranslationService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  powerLimitationLabel(deviceId: string): Observable<PowerLimitationTooltip[]> {
    return this.installationStore.getPowerLimitationLabel(deviceId).pipe(
      map((powerLimitationTooltip) => {
        return powerLimitationTooltip
          .map((el) => ({
            ...el,
            label: this.translateService.instant(
              this.customTranslationService.POWER_LIMITATION_MAPPING[el.label]
            ),
          }))
          .filter((el) => el.label);
      })
    );
  }
}
